import React, { forwardRef } from 'react';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './meta-row.style';

export type MetaRowProps = {
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  /** Leading content the row can't express as an icon (e.g. a progress circle). */
  iconElement?: React.ReactNode;
  label: string;
  isClickable?: boolean;
  isPlaceholder?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
};

export const MetaRow = forwardRef<HTMLSpanElement, MetaRowProps>(
  (
    { icon, iconElement, label, isClickable, isPlaceholder, onClick, children },
    ref,
  ) => (
    <Styled.Row>
      <Styled.LabelColumn>
        <Styled.IconContainer>
          {iconElement ?? (icon ? <Icon icon={icon} /> : null)}
        </Styled.IconContainer>
        <Styled.Label>{label}</Styled.Label>
      </Styled.LabelColumn>

      <Styled.Value
        ref={ref}
        $isClickable={!!isClickable}
        $isPlaceholder={!!isPlaceholder}
        onClick={isClickable ? onClick : undefined}
      >
        {children}
      </Styled.Value>
    </Styled.Row>
  ),
);
